import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import { reducer as profile } from './profile';
import { reducer as dashboard } from './dashboard';
import { reducer as transactions } from './transactions';
import { reducer as payments } from './payments';
import { reducer as anticipations } from './anticipations';
import { reducer as bankAccounts } from './bank-accounts';
import { reducer as rates } from './rates';
import { reducer as banks } from './banks';
import { reducer as compensationStrategies } from './compensation-strategies';
import { reducer as integrations } from './integrations';
import { reducer as customers } from './customers';
import { reducer as products } from './products';
import { reducer as invoices } from './invoices';
import { reducer as developer } from './developer';
import { reducer as antifraud } from './antifraud';
import { reducer as users } from './users';
import { reducer as machines } from './machines';
import { reducer as message } from './message';
import { reducer as snackbar } from './snackbar';

export default history =>
  combineReducers({
    router: connectRouter(history),
    profile,
    dashboard,
    transactions,
    payments,
    anticipations,
    bankAccounts,
    rates,
    banks,
    compensationStrategies,
    integrations,
    customers,
    products,
    invoices,
    developer,
    antifraud,
    users,
    machines,
    message,
    snackbar
  });
